module.exports = __webpack_public_path__ + "img/2-4.5a733466.png";